// extracted by mini-css-extract-plugin
export default {"price":"JN8IH","prevPrice":"ZnEO3","skeleton-progress":"ZubRq"};